export default "__VITE_ASSET__BBBOLDDk__"